import React from "react";
import { Drawer } from "antd";

//components
const SearchSpacesDrawerContent = React.lazy(() => import("./SearchSpacesDrawerContent"));

// interfaces
import { ISearchSpacesDrawer } from "./ISearchSpacesDrawer";

//assets
import styles from "@/assets/styles/containers/search-space-drawer.module.scss";


const SearchSpacesDrawer = (props: ISearchSpacesDrawer) => {
  const { open, onClose, locationName } = props;

  return (
    <Drawer
      title={<span data-testid="locl-search-space-drawer-title">{locationName} Spaces</span>}
      placement="right"
      onClose={onClose}
      open={open}
      rootClassName={styles["locl-search-space-drawer"]}
    >
      <React.Suspense fallback="...">
        { open && <SearchSpacesDrawerContent {...props} /> }
      </React.Suspense>
    </Drawer>
  );
};

export default SearchSpacesDrawer;
